/* AZAROO – ürün sayfası mobil yapışkan satın alma çubuğu
   Kendi formu yoktur; ana Dawn ürün formunun gerçek butonunu tetikler.
   Fiyat / varyant / buton durumu ana formdaki DOM'dan okunur, böylece
   Dawn'ın varyant değişimi (product-info.js) ile her zaman aynı kalır. */
/* Harmony detayları (yalnız görünüm):
   1) Fiyatta kuruş ve para birimi üstte küçük: "1.199,00 TL" -> 1.199 + üstte küçük ,00 TL
   2) Varyant başlığında seçili değer: "BEDEN: 20 CM"
   Dawn varyant değişince bu alanları yeniden çizer; değişiklik izlenip tekrar uygulanır. */
(function () {
  if (window.__azarooPdpDecor) return;
  window.__azarooPdpDecor = true;

  const PRICE_RE = /^(.*?\d)([.,]\d{2})(\s*\D*)$/;

  function decoratePrice(root) {
    root.querySelectorAll('.price--large .price-item').forEach((el) => {
      if (el.querySelector('.az-price-sup')) return;
      const text = el.textContent.trim();
      const m = text.match(PRICE_RE);
      if (!m) return;
      el.textContent = '';
      el.append(document.createTextNode(m[1]));
      const sup = document.createElement('span');
      sup.className = 'az-price-sup';
      sup.textContent = m[2] + (m[3] ? ' ' + m[3].trim() : '');
      el.append(sup);
      el.setAttribute('aria-label', text);
    });
  }

  function decorateLegends(root) {
    root.querySelectorAll('variant-selects fieldset.product-form__input--pill').forEach((fs) => {
      const legend = fs.querySelector('legend');
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (!legend || !checked) return;
      let span = legend.querySelector('.az-selected');
      if (!span) {
        span = document.createElement('span');
        span.className = 'az-selected';
        legend.append(span);
      }
      const value = ': ' + checked.value;
      if (span.textContent !== value) span.textContent = value;
    });
  }

  function run() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      decoratePrice(section);
      decorateLegends(section);
    });
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function start() {
    run();
    document.querySelectorAll('[id^="MainProduct-"]').forEach((section) => {
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true, characterData: true });
      section.addEventListener('change', schedule);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function () {
  if (customElements.get('azaroo-sticky-atc')) return;

  const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

  class AzarooStickyAtc extends HTMLElement {
    connectedCallback() {
      // Hızlı ekleme penceresi veya başka bir modal içinde çalışmasın.
      if (this.closest('quick-add-modal, product-modal, .product-popup-modal, modal-dialog')) {
        this.remove();
        return;
      }
      // Bölümdeki animasyonlu (transform) kapsayıcılar position:fixed'i bozar; body'ye taşı.
      // Taşıma connectedCallback'i yeniden tetikler; başlatma ikinci çağrıda yapılır.
      if (this.parentElement !== document.body) {
        // Aynı sayfada önceki bir kopya varsa (ör. tema düzenleyici yeniden yükleme) onu kaldır.
        document.querySelectorAll('body > azaroo-sticky-atc').forEach((el) => el.remove());
        document.body.appendChild(this);
        return;
      }
      if (this.initialized) return;

      this.section = document.querySelector('[id^="MainProduct-"]');
      if (!this.section) return;
      this.mainButton = this.section.querySelector('.product-form__submit');
      this.priceWrapper = this.section.querySelector('[id^="price-"]');
      this.variantSelects = this.section.querySelector('variant-selects');
      this.button = this.querySelector('[data-az-button]');
      this.priceEl = this.querySelector('[data-az-price]');
      this.variantEl = this.querySelector('[data-az-variant]');
      if (!this.mainButton || !this.button) return;

      this.initialized = true;
      this.init();
    }

    init() {
      this.mainVisible = true;
      this.footerVisible = false;

      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);

      this.sync = this.sync.bind(this);
      this.mutationObserver = new MutationObserver(this.sync);
      this.mutationObserver.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
      if (this.priceWrapper) {
        this.mutationObserver.observe(this.priceWrapper, { childList: true, subtree: true, characterData: true });
      }
      if (this.variantSelects) {
        this.variantSelects.addEventListener('change', () => window.requestAnimationFrame(this.sync));
      }

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.mainButton) this.mainVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
          if (entry.target === this.footer) this.footerVisible = entry.isIntersecting;
        });
        this.updateVisibility();
      });
      this.intersectionObserver.observe(this.mainButton);
      this.footer = document.querySelector('.footer, footer');
      if (this.footer) this.intersectionObserver.observe(this.footer);

      this.onMediaChange = this.updateVisibility.bind(this);
      if (MOBILE_QUERY.addEventListener) MOBILE_QUERY.addEventListener('change', this.onMediaChange);

      this.sync();
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      if (MOBILE_QUERY.removeEventListener && this.onMediaChange) MOBILE_QUERY.removeEventListener('change', this.onMediaChange);
    }

    sync() {
      // Buton durumu ve metni: ana butonla birebir
      const disabled = this.mainButton.hasAttribute('disabled') || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = disabled;
      const label = this.mainButton.querySelector('span:not(.visually-hidden)');
      const text = (label ? label.textContent : this.mainButton.textContent).trim();
      if (text) this.button.textContent = text;

      // Fiyat: ana fiyat alanında görünen satış fiyatı
      if (this.priceWrapper && this.priceEl) {
        const price = this.priceWrapper.querySelector('.price');
        let item = null;
        if (price) {
          item = price.classList.contains('price--on-sale')
            ? price.querySelector('.price__sale .price-item--last')
            : price.querySelector('.price__regular .price-item--regular');
        }
        const priceText = item ? item.textContent.trim() : '';
        if (priceText) this.priceEl.textContent = priceText;
      }

      // Seçili varyant adı
      if (this.variantSelects && this.variantEl) {
        const values = [];
        this.variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
          const checked = group.querySelector('input:checked');
          const select = group.querySelector('select');
          if (checked) values.push(checked.value);
          else if (select) values.push(select.value);
        });
        if (values.length) this.variantEl.textContent = values.join(' / ');
      }
    }

    updateVisibility() {
      const show = MOBILE_QUERY.matches && !this.mainVisible && !this.footerVisible;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.button.tabIndex = show ? 0 : -1;
    }

    onClick() {
      if (this.button.disabled || this.mainButton.hasAttribute('disabled')) return;
      // Gerçek ürün formunu gönderir (Dawn AJAX sepete ekleme, sepet çekmecesi vb. aynen çalışır)
      this.mainButton.click();
    }
  }

  customElements.define('azaroo-sticky-atc', AzarooStickyAtc);
})();
